import Axios from 'axios';

Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';
Axios.defaults.headers.common['X-Accept'] = 'application/json';

export default class EventListingService {
  static instance = null;

  baseUrl = '/api/v3/selfservice/event-listing';

  constructor() {
    if (EventListingService.instance) {
      return EventListingService.instance;
    }
    EventListingService.instance = this;
  }

  async getEventListing(token) {
    const url = `${this.baseUrl}/${token}/`;
    const response = await Axios.get(url);
    if (response.status !== 200) {
      throw new Error(`Failed to get event listing: ${response.status}`);
    }
    return response.data;
  }

  async createEventListingPurchase(event) {
    const formData = new FormData();
    Object.keys(event).forEach((key) => {
      formData.append(key, event[key]);
    });
    const response = await Axios.post(`${this.baseUrl}/`, formData);
    if (response.status !== 201) {
      throw new Error(`Failed to create event listing purchase: ${response.status}`);
    }
    return response.data;
  }

  async updateEventListing(purchaseToken, event) {
    const formData = new FormData();
    Object.keys(event).forEach((key) => {
      if (!(event[key] === null)) {
        formData.append(key, event[key]);
      }
    });
    const response = await Axios.patch(`${this.baseUrl}/${purchaseToken}/`, formData);
    if (response.status !== 200) {
      throw new Error(`Failed to update event listing: ${response.status}`);
    }
    return response.data;
  }

  async deleteEventListing(purchaseToken) {
    const response = await Axios.delete(`${this.baseUrl}/${purchaseToken}/`);
    if (response.status !== 200) {
      throw new Error(`Failed to delete event listing: ${response.status}`);
    }
    return response.data;
  }
}
